
export default function ServiceDefinition() {
  return (
    <section id="about" className="py-24 lg:py-32 bg-[#f8fafc] relative overflow-hidden">
      {/* 背景装飾 */}
      <div className="absolute top-0 left-0 w-full h-full opacity-30">
        <div className="absolute top-20 right-20 w-64 h-64 bg-[#12335f]/5 rounded-full"></div>
        <div className="absolute bottom-40 left-10 w-48 h-48 bg-[#153577]/5 rounded-full"></div>
      </div>
      
      <div className="max-w-6xl mx-auto px-6 lg:px-12 relative z-10">
        {/* ヘッダー */}
        <div className="text-center mb-16">
          <span className="inline-block px-5 py-2 bg-[#12335f]/10 text-[#12335f] text-sm font-medium rounded-full mb-6 tracking-wider">
            Our Approach
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-[#12335f]">
            デジポップブーストのDX支援について
          </h2>
        </div>

        {/* コンテンツブロック1: 左テキスト・右画像 */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 mb-12 items-center">
          <div className="bg-white rounded-2xl p-8 lg:p-10 shadow-sm border border-gray-100">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center bg-[#12335f]/10 rounded-lg">
                <i className="ri-lightbulb-line text-xl text-[#12335f]"></i>
              </div>
              <h3 className="text-lg font-bold text-[#12335f]">私たちの考え方</h3>
            </div>
            <p className="text-base text-gray-700 leading-relaxed">
              デジポップブーストは、DXをツール導入や一時的な施策で終わらせる支援ではありません。<br /><br />
              新しいツールを入れることや、部分的な改善そのものを目的にするのではなく、「何から始めて、どの順番で進めるのか」という最初の段階から一緒に考えることを重視しています。
            </p>
          </div>
          <div className="relative">
            <img 
              src="https://static.readdy.ai/image/a52a13a88e2ccb39325c6dcb34729469/e7f89442f46b27c2b04ee10095383774.png"
              alt="チームコラボレーション"
              className="w-full h-64 lg:h-80 object-cover rounded-2xl shadow-sm"
            />
            <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-lg shadow-sm">
              <span className="text-sm text-[#12335f] font-medium">最初の段階から一緒に</span>
            </div>
          </div>
        </div>

        {/* コンテンツブロック2: 左画像・右テキスト */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 mb-12 items-center">
          <div className="relative order-2 lg:order-1">
            <img 
              src="https://static.readdy.ai/image/a52a13a88e2ccb39325c6dcb34729469/c3b8e93b3496ff488ca7f5222f62a448.png"
              alt="業務分析"
              className="w-full h-64 lg:h-80 object-cover rounded-2xl shadow-sm"
            />
            <div className="absolute bottom-4 right-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-lg shadow-sm">
              <span className="text-sm text-[#12335f] font-medium">現実的な形を整理</span>
            </div>
          </div>
          <div className="bg-white rounded-2xl p-8 lg:p-10 shadow-sm border border-gray-100 order-1 lg:order-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center bg-[#12335f]/10 rounded-lg">
                <i className="ri-compass-3-line text-xl text-[#12335f]"></i>
              </div>
              <h3 className="text-lg font-bold text-[#12335f]">現場に寄り添う支援</h3>
            </div>
            <p className="text-base text-gray-700 leading-relaxed">
              多くの現場では、ツールや手法の選択肢が先に増え、自社の状況に合った進め方を考える前に、判断が難しくなってしまうケースが少なくありません。<br /><br />
              デジポップブーストでは、そうした状態を前提に、業務内容や体制、リソースを踏まえたうえで、現実的に進められる形を整理していきます。
            </p>
          </div>
        </div>

        {/* ハイライトセクション */}
        <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-sm border border-gray-100 mb-12">
          <div className="grid lg:grid-cols-5 gap-8 items-center">
            <div className="lg:col-span-3">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center bg-[#12335f] rounded-lg">
                  <i className="ri-focus-3-line text-xl text-white"></i>
                </div>
                <h3 className="text-lg font-bold text-[#12335f]">私たちが目指すもの</h3>
              </div>
              <p className="text-base lg:text-lg text-[#12335f] font-medium leading-relaxed mb-6">
                目指しているのは、「導入した」で終わらせないDXです。<br />
                実際の業務の中で使われ、無理なく回り続ける状態になること。<br />
                そのために、計画だけで終わらせず、実行し、必要に応じて見直しながら、現場に定着するところまで伴走します。
              </p>
            </div>
            <div className="lg:col-span-2 flex justify-center">
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-[#12335f]/5 rounded-xl p-5 text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-white rounded-lg mx-auto mb-3 shadow-sm">
                    <i className="ri-settings-4-line text-2xl text-[#12335f]"></i>
                  </div>
                  <span className="text-sm text-[#12335f] font-medium">計画</span>
                </div>
                <div className="bg-[#12335f]/5 rounded-xl p-5 text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-white rounded-lg mx-auto mb-3 shadow-sm">
                    <i className="ri-rocket-line text-2xl text-[#12335f]"></i>
                  </div>
                  <span className="text-sm text-[#12335f] font-medium">実行</span>
                </div>
                <div className="bg-[#12335f]/5 rounded-xl p-5 text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-white rounded-lg mx-auto mb-3 shadow-sm">
                    <i className="ri-refresh-line text-2xl text-[#12335f]"></i>
                  </div>
                  <span className="text-sm text-[#12335f] font-medium">見直し</span>
                </div>
                <div className="bg-[#12335f]/5 rounded-xl p-5 text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-white rounded-lg mx-auto mb-3 shadow-sm">
                    <i className="ri-check-double-line text-2xl text-[#12335f]"></i>
                  </div>
                  <span className="text-sm text-[#12335f] font-medium">定着</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 結論セクション */}
      </div>
      <div className="bg-gradient-to-r from-[#12335f] to-[#1a4a7a] p-8 lg:p-10 mt-12">
        <div className="max-w-3xl mx-auto">
          <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-full mb-6 mx-auto">
            <i className="ri-arrow-right-circle-line text-3xl text-white"></i>
          </div>
          <p className="text-base lg:text-lg text-white leading-relaxed text-left">
            「とりあえず導入する」のではなく、進め方に迷わず、次に何をすべきかが分かる状態をつくること。それが、デジポップブーストのDX支援です。
          </p>
        </div>
      </div>
    </section>
  );
}
